import { AlertConfig } from '../models';
import { ModelResource } from './resource';

export class AlertConfigs extends ModelResource<AlertConfig> {
  model = AlertConfig;

  resourcePath = 'v1/alert-configs';
}
